import { memo } from 'react';
import styled from 'styled-components';

const StyledTableHeader = styled.thead`
  margin: 0;
  padding: 0;
  background-color: #dcdbc1; /* Header background color */

  /* Sticky header support */
  ${({ sticky }) =>
    sticky === 'Yes' &&
    `
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #dcdbc1; 
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    border-bottom: 1px solid #dbeafe; /* Header border color */
  `}
`;

const TableHeader = memo(({ children, sticky = 'No' }) => (
  <StyledTableHeader sticky={sticky}>{children}</StyledTableHeader>
));

export default TableHeader;
